import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { FsFormatDatePipe } from '@lib/common/pipes';

import { AxonNotificationIconService } from '../../services/axon-notification-icon.service';

@Component({
  selector: 'fs-axon-notification-icon',
  templateUrl: './axon-notification-icon.component.html',
  styleUrls: ['./axon-notification-icon.component.scss'],
})
export class AxonNotificationIconComponent implements OnInit {
  @Input()
  public content: any;

  @Input()
  public showTooltip: boolean = true;

  public tooltip: string;

  constructor(
    private _sanitizer: DomSanitizer,
    private _axonNotificationIconService: AxonNotificationIconService,
  ) {}

  public ngOnInit(): void {
    this.tooltip = this.generateTooltip(this.content);
  }

  public generateTooltip(content: any): string {
    return `${content.data.messageTranslation} - ${new FsFormatDatePipe().transform(
      content.data.notification.notificationReceivedTime,
      'HH:mm',
    )}hrs`;
  }

  public getIconHTML(): SafeHtml {
    // Get notification type from the data structure
    let notificationType = this.content?.data?.notification?.category;

    // Default fallback
    if (!notificationType) {
      notificationType = 'WatchMeActivate';
    }

    // Use the service method to generate the HTML
    const htmlString = this._axonNotificationIconService.generateIconHTML(notificationType);
    return this._sanitizer.bypassSecurityTrustHtml(htmlString);
  }
}
